const AuctionTypes = {
  GET_SPOTBID_SEARCH_RESULTS_PROGRESS: 'AUCTION_TYPE.GET_SPOTBID_SEARCH_RESULTS_PROGRESS',
  GET_SPOTBID_SEARCH_RESULTS_SUCCESS: 'AUCTION_TYPE.GET_SPOTBID_SEARCH_RESULTS_SUCCESS',
  GET_SPOTBID_SEARCH_RESULTS_ERROR: 'AUCTION_TYPE.GET_SPOTBID_SEARCH_RESULTS_ERROR',
  SET_SEARCH_FILTERS: 'AUCTION_TYPE.SET_SEARCH_FILTERS',
  SET_SPOTBID_SEARCH_RESULTS: 'AUCTION_TYPE.SET_SPOTBID_SEARCH_RESULTS',
  GET_SHIPMENT_PRODUCT_DETAIL_PROGRESS: 'AUCTION_TYPE.GET_SHIPMENT_PRODUCT_DETAIL_PROGRESS',
  GET_SHIPMENT_PRODUCT_DETAIL_SUCCESS: 'AUCTION_TYPE.GET_SHIPMENT_PRODUCT_DETAIL_SUCCESS',
  GET_SHIPMENT_PRODUCT_DETAIL_ERROR: 'AUCTION_TYPE.GET_SHIPMENT_PRODUCT_DETAIL_ERROR',
  SET_SPOTBID_SAVE_PROGRESS: 'AUCTION_TYPE.SET_SPOTBID_SAVE_PROGRESS',
  SET_SPOTBID_DECLINE_PROGRESS: 'AUCTION_TYPE.SET_SPOTBID_DECLINE_PROGRESS',
  SET_SPOTBID_SAVE_ERROR: 'AUCTION_TYPE.SET_SPOTBID_SAVE_ERROR',
  SET_SPOTBID_DECLINE_ERROR: 'AUCTION_TYPE.SET_DECLINE_SAVE_ERROR',
  SET_SPOTBID_SAVE_SUCCESS: 'AUCTION_TYPE.SET_SPOTBID_SAVE_SUCCESS',
  SET_SPOTBID_DECLINE_SUCCESS: 'AUCTION_TYPE.SET_SPOTBID_DECLINE_SUCCESS',
  SET_SPOTBID_SAVE_STATUS_DEFAULT: 'AUCTION_TYPE.SET_SPOTBID_SAVE_STATUS_DEFAULT',
  GET_SPOTBID_EXPORT_SEARCH_RESULTS_PROGRESS: 'AUCTION_TYPE.GET_SPOTBID_EXPORT_SEARCH_RESULTS_PROGRESS',
  GET_SPOTBID_EXPORT_SEARCH_RESULTS_SUCCESS: 'AUCTION_TYPE.GET_SPOTBID_EXPORT_SEARCH_RESULTS_SUCCESS',
  GET_SPOTBID_EXPORT_SEARCH_RESULTS_ERROR: 'AUCTION_TYPE.GET_SPOTBID_EXPORT_SEARCH_RESULTS_ERROR',
  GET_SPOTBID_RESULTS_SUBMIT_PROGRESS: 'AUCTION_TYPE.GET_SPOTBID_RESULTS_SUBMIT_PROGRESS',
  SET_SPOTBID_TOTAL_COUNT: 'AUCTION_TYPE.SET_SPOTBID_TOTAL_COUNT',
  SET_SELECTED_SPOTBID: 'AUCTION_TYPE.SET_SELECTED_SPOTBID',
  GET_SPOTBID_LIST_SUMBIT_SUCCESS: 'AUCTION_TYPE.GET_SPOTBID_LIST_SUMBIT_SUCCESS',
  SET_SPOTBID_VALUE_DEFAULT: 'AUCTION_TYPE.SET_SPOTBID_VALUE_DEFAULT',
  GET_DOCUMENTS_PROGRESS: 'AUCTION_TYPE.GET_DOCUMENTS_PROGRESS',
  GET_DOCUMENTS_SUCCESS: 'AUCTION_TYPE.GET_DOCUMENTS_SUCCESS',
  GET_DOCUMENTS_ERROR: 'AUCTION_TYPE.GET_DOCUMENTS_ERROR',
  GET_MULTI_QUOTE_PROGRESS: 'AUCTION_TYPE.GET_MULTI_QUOTE_PROGRESS',
  GET_MULTI_QUOTE_SUCCESS: 'AUCTION_TYPE.GET_MULTI_QUOTE_SUCCESS',
  GET_MULTI_QUOTE_ERROR: 'AUCTION_TYPE.GET_MULTI_QUOTE_ERROR',
};
export default AuctionTypes;
